"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.smallRomanValue = exports.bigRomanValue = void 0;
/**
 * cache symboli rzymskich, wielkie litery
 */
var BIG_ROMANS_CACHE = [];
/**
 * cache symboli rzymskich, małe litery
 */
var SMALL_ROMANS_CACHE = [];
/**
 * jednostki w zapisie rzymskim, wielkie litery
 */
var BIG_ROMANS_UNITS = [
    ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'],
    ['', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'],
    ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'],
    ['', 'M', 'MM', 'MMM', '', '', '', '', '', '']
];
/**
 * jednostki w zapisie rzymskim, małe litery
 */
var SMALL_ROMANS_UNITS = [
    ['', 'i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix'],
    ['', 'x', 'xx', 'xxx', 'xl', 'l', 'lx', 'lxx', 'lxxx', 'xc'],
    ['', 'c', 'cc', 'ccc', 'cd', 'd', 'dc', 'dcc', 'dccc', 'cm'],
    ['', 'm', 'mm', 'mmm', '', '', '', '', '', '']
];
/**
 * uniwersalna funkcja do zamiany liczby na liczbę rzymską
 *
 * @param {number} value liczba
 * @param {string[][]} units tablica jednostek w zapisie rzymskim
 * @param {string[]} cache cache wyników
 * @returns
 */
function romanValue(value, units, cache) {
    if (value > 3999)
        return '';
    if (cache[value] !== undefined) {
        return cache[value];
    }
    var level = 0;
    var ivalue = value;
    var result = '';
    while (ivalue > 0) {
        var dvalue = ivalue % 10;
        result = units[level][dvalue] + result;
        if (dvalue === ivalue) {
            break;
        }
        ivalue = Math.floor(ivalue / 10);
        level++;
    }
    return (cache[value] = result);
}
/**
 * zmiana liczy na zapis rzymski, wielkimi literami
 * 1-I, 2-II .... 10-X ...
 *
 * @export
 * @param {number} value liczba
 * @returns {string} liczba w zapisie rzymskim
 */
function bigRomanValue(value) {
    return romanValue(value, BIG_ROMANS_UNITS, BIG_ROMANS_CACHE);
}
exports.bigRomanValue = bigRomanValue;
/**
 * zmiana liczy na zapis rzymski, małymi literami
 * 1-i, 2-ii .... 10-x ...
 *
 * @export
 * @param {number} value liczba
 * @returns {string} liczba w zapisie rzymskim
 */
function smallRomanValue(value) {
    return romanValue(value, SMALL_ROMANS_UNITS, SMALL_ROMANS_CACHE);
}
exports.smallRomanValue = smallRomanValue;
//# sourceMappingURL=romanValue.js.map